import axios from 'axios'
const CryptoJS = require("crypto-js");
function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
      const value = params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && value !== "" && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              var subPart = encodeURIComponent(params) + "=";
              result += subPart + encodeURIComponent(value[key]) + "&";
            }
          }
        } else {
          result += part + encodeURIComponent(value) + "&";
        }
      }
    }
    return result
  }
let userData = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 20000
})
// request拦截器
service.interceptors.request.use(config => {
    let time = new Date().getTime()
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // get请求映射params参数
    
    if (config.method === 'get' && config.params) {
        let str = `Harzone@123${time}`
        let sign = CryptoJS.MD5(str).toString();
        let url = config.url + `/${sign}/${time}`
        url += '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        let data = config.data?JSON.parse(JSON.stringify(config.data)):{}
        if(config.url == "/pet/web/upload"){
            let str = `Harzone@123${time}`
            let sign = CryptoJS.MD5(str).toString();
            config.url = config.url + `/${sign}/${time}`
        }else{
            let str = `Harzone@123${time}`
            // if(userData&&userData.openId&&userData.userId){
            //     // str = `Harzone@123${userData.openId}${userData.userId}${time}`
            //     data.userIdCard = userData.userId
            //     data.openId = userData.openId
            // }
            if(userData&&userData.openId){
                data.openId = userData.openId
            }
            if(userData&&userData.userId){
                data.userIdCard = userData.userId
            }
            // if(config.url == "/pet/web/selectListByOpenId"){
            //     str = `Harzone@123${userData.openId}${time}`
            // }else if(config.url == "/pet/web/selectDogCertificateByUserIdCardOrNo"){
            //     str = `Harzone@123${userData.userId}${time}`
            // }else if(config.url == "/pet/web/binding"){
            //     str = `Harzone@123${config.data.plateNo}${config.data.petInfoUuid}${time}`
            // }else if(config.url == "/pet/web/wx/userinfo"){
            //     str = `Harzone@123${config.data.code}${time}`
            // }else if(config.url == "/pet/web/selectBindingByPlateNo"){
            //     str = `Harzone@123${config.data.plateNo}${time}`
            // }else if(config.url == "/pet/web/wy/liveperson/audit"){
            //     str = `Harzone@123${config.data.token}${time}`
            // }
            let sign = CryptoJS.MD5(str).toString();
            // console.log(str);
            // console.log(sign);
            // return
            data.timestamp = time
            data.sign = sign
            config.data = data
            console.log(config);
        }
    }
    return config
  }, error => {
      Promise.reject(error)
  })
export function fetch(url,params = {}){
    return new Promise((resolve,reject)=>{
        service.get(url,{
            params:params
        }).then(response=>{
            resolve(response)
        }).catch(err=>{
            reject(err)
        })
    })
}
export function post(url,data = {},config={}){
    return new Promise((resolve,reject)=>{
        service.post(url,data,config).then(response=>{
            resolve(response)
        }).catch(err=>{
            reject(err)
        })
    })
}
export function put(url,data = {}){
    return new Promise((resolve,reject)=>{
        service.put(url,data).then(response=>{
            resolve(response)
        }).catch(err=>{
            reject(err)
        })
    })
}


export default service


